import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
export default function makeSingle(baseClass) {
    var SingleObjectResource = function (_baseClass) {
        _inherits(SingleObjectResource, _baseClass);

        function SingleObjectResource() {
            _classCallCheck(this, SingleObjectResource);

            return _possibleConstructorReturn(this, (SingleObjectResource.__proto__ || _Object$getPrototypeOf(SingleObjectResource)).apply(this, arguments));
        }

        _createClass(SingleObjectResource, [{
            key: 'fetch',
            value: function fetch(kwargs, query) {
                var requestConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                var method = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'get';

                var thePath = this.buildThePath(kwargs, requestConfig);
                return this.handleRequest(this.createRequest(method, thePath, query, null, null, requestConfig), requestConfig);
            }
        }, {
            key: 'head',
            value: function head(kwargs, query) {
                var requestConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

                return this.fetch(kwargs, query, requestConfig, 'head');
            }
        }, {
            key: 'options',
            value: function options(kwargs, query) {
                var requestConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

                return this.fetch(kwargs, query, requestConfig, 'options');
            }
        }, {
            key: 'post',
            value: function post(kwargs, data, query, attachments) {
                var requestConfig = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
                var method = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'post';

                var thePath = this.buildThePath(kwargs, requestConfig);

                return this.handleRequest(this.createRequest(method, thePath, query, data || {}, attachments, requestConfig), requestConfig);
            }
        }, {
            key: 'patch',
            value: function patch(kwargs, data, query, attachments) {
                var requestConfig = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

                return this.post(kwargs, data, query, attachments, requestConfig, 'patch');
            }
        }, {
            key: 'put',
            value: function put(kwargs, data, query, attachments) {
                var requestConfig = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

                return this.post(kwargs, data, query, attachments, requestConfig, 'put');
            }
        }, {
            key: 'del',
            value: function del(kwargs, data, query, attachments) {
                var requestConfig = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

                return this.post(kwargs, data, query, attachments, requestConfig, 'del');
            }
        }]);

        return SingleObjectResource;
    }(baseClass);

    return SingleObjectResource;
}


//////////////////
// WEBPACK FOOTER
// ../~/tg-resources/es/single.js
// module id = 843
// module chunks = 0